import React, { createContext, useContext, useMemo } from 'react';

interface AssetConfigValue {
  readonly publicAssetServerUrl: string;
}

const defaultValue: AssetConfigValue = {
  publicAssetServerUrl: '',
};

const AssetConfigContext = createContext<AssetConfigValue>(defaultValue);

export function AssetConfigProvider(props: {
  readonly publicAssetServerUrl?: string;
  readonly children: React.ReactNode;
}) {
  const value = useMemo<AssetConfigValue>(
    () => ({
      publicAssetServerUrl: props.publicAssetServerUrl || '',
    }),
    [props.publicAssetServerUrl],
  );

  return (
    <AssetConfigContext.Provider value={value}>
      {props.children}
    </AssetConfigContext.Provider>
  );
}

export function useAssetConfig(): AssetConfigValue {
  return useContext(AssetConfigContext);
}
